module.exports = __webpack_public_path__ + "media/images/wfc/city-6-bb2636e75352b484483f8f39633600e5.jpg";